export enum ActivityType {
  UnitUpdated = 76,
};